import { useEffect } from 'react';
import axios from 'axios';
import i18n from '../i18n';

const LanguageDetector = () => {
  useEffect(() => {
    const detectLanguage = async () => {
      try {
        // Only detect if language hasn't been set yet
        const currentLanguage = localStorage.getItem('i18nextLng');
        
        // If language is already set to a specific language (not just the default), don't override
        if (currentLanguage && ['en', 'de'].includes(currentLanguage)) {
          return;
        }
        
        // Use free IP geolocation API
        const response = await axios.get('https://ipapi.co/json/');
        const countryCode = response.data.country_code;
        
        // Set German for German-speaking countries (Germany, Austria, Switzerland)
        if (['DE', 'AT', 'CH'].includes(countryCode)) {
          i18n.changeLanguage('de');
        } else {
          i18n.changeLanguage('en');
        }
      } catch (error) {
        console.error('Error detecting language from IP:', error);
        // Fallback to browser language detection (already handled by i18next)
      }
    };
    
    detectLanguage();
  }, []);
  
  // This component doesn't render anything
  return null;
};

export default LanguageDetector;
